import React, { useState, useEffect } from 'react';
import '../../../assets/css/subscreens/customer/contact/Contactform.css';

const Contactform = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = () => {
    console.log('Form submitted:', formData);
    alert('Thank you for contacting us! We will get back to you soon.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
  };

  return (
    <section className="contact-form-section">
      
      {/* ===== TOP CENTER HEADING ===== */}
      <div className="contact-top-heading">
        <h1>Contact Us</h1>
        <p>We’d love to hear from you. Get in touch with our team.</p>
      </div>

      <div className="contact-form-container">
        {/* Left Side - Description */}
        <div className={`contact-description ${isVisible ? 'slide-in-left' : ''}`}>
          <div className="description-badge">
            <span className="badge-text">Get In Touch</span>
          </div>

          <h2 className="description-title">
            Let's Work Together
          </h2>

          <p className="description-text">
            Have a question or need a service? We're here to help! Fill out the form and our team 
            will get back to you within 24 hours. Whether you need an electrician, plumber, painter, 
            cook, or home cleaner, WorkHub connects you with trusted professionals.
          </p>

          <div className="description-features">
            <div className="feature-item">
              <div className="feature-content">
                <h4 className="feature-title">Quick Response</h4>
                <p className="feature-text">We respond to all inquiries within 24 hours</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-content">
                <h4 className="feature-title">Trusted Service</h4>
                <p className="feature-text">All professionals are verified and background-checked</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-content">
                <h4 className="feature-title">Quality Guarantee</h4>
                <p className="feature-text">100% satisfaction guarantee on all services</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Form */}
        <div className={`contact-form-wrapper ${isVisible ? 'slide-in-right' : ''}`}>
          <div className="contact-form">
            <h3 className="form-title">Send us a Message</h3>
            <p className="form-subtitle">Fill out the form below and we'll get back to you soon</p>

            <div className="form-group">
              <label htmlFor="name" className="form-label">Full Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="form-input"
                placeholder="Enter your full name"
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="email" className="form-label">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="your@email.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone" className="form-label">Phone Number *</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="+92 300 1234567"
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="subject" className="form-label">Subject *</label>
              <select
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                className="form-select"
              >
                <option value="">Select a service</option>
                <option value="Electrician">Electrician</option>
                <option value="Plumber">Plumber</option>
                <option value="Painter">Painter</option>
                <option value="Cook">Cook</option>
                <option value="Home Cleaner">Home Cleaner</option>
                <option value="Other">Other Inquiry</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="message" className="form-label">Message *</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                className="form-textarea"
                placeholder="Tell us about your requirements..."
                rows={5}
              />
            </div>

            <button onClick={handleSubmit} className="form-submit-btn">
              Send Message
              <span className="btn-arrow">→</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contactform;